import React, { useCallback } from 'react';

import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { CardModal } from 'components/card-modal';
import useCartAddOns from 'hooks/use-cart-add-ons';
import useFeatureMenuAddOn from 'hooks/use-feature-menu-add-on';
import { useModalAnalyticsAppearanceEvent } from 'hooks/use-modal-analytics-appearance-event';
import { useUIContext } from 'state/ui';

import { AddExtrasContent } from './add-extras-content';

export const AddExtrasModal: React.FC = () => {
  const { formatMessage } = useIntl();
  const { sections } = useFeatureMenuAddOn();

  const {
    totalPrice,
    totalQuantity,
    handleAddToCart,
    isEdit,
    addOnSelections,
    updateQuantityForItem,
  } = useCartAddOns({ addOnData: sections });

  const router = useRouter();

  const { formatCurrencyForLocale } = useUIContext();

  const onAddExtras = useCallback(() => {
    handleAddToCart();
    router.dismiss();
  }, [handleAddToCart]);

  const actionButtonAccessibilityLabel = formatMessage(
    { id: 'addQuantityAndItemWithPrice' },
    {
      itemName: `Extra${totalQuantity > 1 ? 's' : ''}`,
      quantity: totalQuantity,
      price: formatCurrencyForLocale(totalPrice),
    }
  );

  const actionButtonText = [
    formatMessage({
      id: isEdit ? 'updateCart' : 'addToOrder',
    }),
    formatCurrencyForLocale(totalPrice),
  ].join(' — ');

  const heading = formatMessage({ id: 'addCondiments' });
  useModalAnalyticsAppearanceEvent(heading);

  return (
    <CardModal
      analyticsEvent={heading}
      headerText={heading}
      scrollView
      footer={
        <ActionButton
          fullWidth
          accessibilityLabel={actionButtonAccessibilityLabel}
          testID="extras-add-to-order-button"
          perceptible
          onPress={onAddExtras}
        >
          {actionButtonText}
        </ActionButton>
      }
    >
      <AddExtrasContent
        addOns={sections}
        addOnSelections={addOnSelections}
        updateQuantityForitem={updateQuantityForItem}
      />
    </CardModal>
  );
};
